import { useState } from "react";
import "./App.css";
import {
  LandingScreen,
  Navigation,
  Introduction,
  AboutSection,
  SkillsSection,
  ProjectsSection,
  ContactSection,
  Footer,
} from "./components";
import { SKILLS, IMAGES, PROJECTS } from "./data/content";

// Main App
function App() {
  // const [showMatchFound, setShowMatchFound] = useState(true);
  const [showMatchFound, setShowMatchFound] = useState(() => {
    const visitedAt = localStorage.getItem("visitedAt");

    if (!visitedAt) return true;

    const now = Date.now();
    const diff = now - visitedAt;

    const ONE_DAY = 1000 * 60 * 60 * 24;

    return diff > ONE_DAY; // show again if more than 1 day
  });
  const [fadeOut, setFadeOut] = useState(false);

  const handleMatchComplete = () => {
    setFadeOut(true);

    setTimeout(() => {
      setShowMatchFound(false);
      localStorage.setItem("visitedAt", Date.now());
    }, 50);
  };

  return (
    <div className="App" data-testid="app-container">
      {/* Match Found Loading Screen */}
      {showMatchFound && (
        <div
          className={`transition-opacity duration-500 ${fadeOut ? "opacity-0" : "opacity-100"}`}
        >
          <LandingScreen onComplete={handleMatchComplete} />
        </div>
      )}

      {/* Main Content */}
      <div
        className={`transition-opacity duration-500 ${showMatchFound && !fadeOut ? "opacity-0" : "opacity-100"}`}
      >
        {/* Noise Overlay for texture */}
        <div className="noise-overlay" />

        <Navigation />
        <Introduction images={IMAGES} />
        <AboutSection images={IMAGES} />
        <SkillsSection skills={SKILLS} />
        <ProjectsSection projects={PROJECTS} />
        <ContactSection />
        <Footer />
      </div>
    </div>
  );
}

export default App;
